import { Component, OnInit, ViewChild } from '@angular/core';
import { directus, Edizione } from '../../../../directus';
import { readItem, readItems } from '@directus/sdk';
import { ActivatedRoute } from '@angular/router';
import { EdizioneObj } from '../../classes/edizione-obj';
import { CanvasBadgeComponent } from '../canvas-badge/canvas-badge.component';
import { environment } from '../../../environments/environment';
import { IscrizioneObj } from '../../classes/iscrizione-obj';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { AppComponent } from '../../app.component';

@Component({
  selector: 'app-print-badges',
  standalone: true,
  imports: [CommonModule, CanvasBadgeComponent],
  templateUrl: './print-badges.component.html',
  styles: ['#main { padding: 0 0 important!; }']
})
export class PrintBadgesComponent implements OnInit {
  edizione: EdizioneObj | undefined;
  iscritti: IscrizioneObj[] | undefined;
  route: ActivatedRoute;

  @ViewChild(CanvasBadgeComponent)
  badge_component!: CanvasBadgeComponent;

  app: AppComponent;

  id_edizione: any;

  constructor(private _route: ActivatedRoute, private domSanitizer: DomSanitizer, private _app: AppComponent) {
    this.route = _route;
    this.app = _app;
  }
  async ngOnInit(): Promise<void> {
    const self = this;
    var mainElement: HTMLElement | null = document.getElementById("main");
    if (mainElement) {
      mainElement.style['padding'] = '0';
      mainElement.style['margin'] = '0';
    }

    if (this.route.snapshot.paramMap.get('id')) {
      const _id = this.route.snapshot.paramMap.get('id');
      if (_id) {
        const __id = _id as unknown as number;
        self.id_edizione = _id;
        self.app.showSpinner();

        await this.getEdizioneById(__id);
        if (this.edizione && this.edizione != undefined) {
          const _idEd = Number(this.edizione.id);

          if (this.route.snapshot.paramMap.get('idIscr')) {
            const _idI = this.route.snapshot.paramMap.get('idIscr');
            const _idIscr = Number(_idI);

            this.getIscrizione(_idEd, _idIscr).then((_iscr: IscrizioneObj[]) => {
              self.iscritti = _iscr;
              this.printBadges();
            });
          } else {
            this.getAllIscrizioni(_idEd).then((_iscr: IscrizioneObj[]) => {
              self.iscritti = _iscr;
              this.printBadges();
            });
          }
        } else {
          self.app.hideSpinner();
        }

      } else {
        self.app.hideSpinner();
        alert(' Edizione non trovata!');
      }
    }
  }
  /*
  EDIZIONE
  */
  async getEdizioneById(id: number) {
    const _ed: Edizione = await directus
      .request<Edizione>(readItem('edizione', id));
    this.edizione = new EdizioneObj(_ed);
  }

  /*ISCRITTI CONFERMATI*/
  async getAllIscrizioni(_id: number): Promise<IscrizioneObj[]> {
    const self = this;
    return new Promise(async (resolve, reject) => {
      try {
        const _iscritti = await directus
          .request<IscrizioneObj[]>(readItems("iscrizioni", {
            filter: {
              "edizione": {
                "_eq": _id
              },
              "confermata": {
                "_eq": 1
              }
            },
            fields: ["id", "status", "nome", "cognome", "azienda", "email", "profilo", "edizione", "confermata", "presenza", "orario"],
            sort: ['date_created'], //Sort by sort field and creation date descending
          }));
        resolve(_iscritti);

      } catch (error: any) {
        error = JSON.parse(JSON.stringify(error));
        console.error(error);
        reject(error);
      }
    });
  }
  async getIscrizione(_id: number, _iscrT: number): Promise<IscrizioneObj[]> {
    const self = this;
    return new Promise(async (resolve, reject) => {
      try {
        const _iscritti = await directus
          .request<IscrizioneObj[]>(readItems("iscrizioni", {
            filter: {
              "id": _iscrT,
              "edizione": {
                "_eq": _id
              }
              /*,
              "confermata": {
                "_eq": 1
              }*/
            },
            fields: ["id", "status", "nome", "cognome", "azienda", "email", "edizione", "profilo", "edizione", "confermata", "presenza"],
            sort: ['date_created'], //Sort by sort field and creation date descending
          }));
        resolve(_iscritti);

      } catch (error: any) {
        error = JSON.parse(JSON.stringify(error));
        console.error(error);
        reject(error);
      }
    });
  }
  async printBadges() {
    const self = this;
    let _i = 0;
    if (self.edizione && self.iscritti && self.iscritti != undefined && self.iscritti.length > 0) {
      //self.badge_component.setEdizioneById(self.edizione.id.toString());
      for (const _iscritto of self.iscritti) {
        if (_iscritto && _iscritto != undefined) {


          self.badge_component.setBadgeText(_iscritto.nome + ' ' + _iscritto.cognome + '\n' + _iscritto.azienda + (_iscritto.profilo ? (+ '\n' + _iscritto.profilo) : ''));

          //self.badge_component.setBadgeURL(environment.apiUrl + environment.presence_subscription_route + '/' + _iscritto.id);
          self.badge_component.setBadgeURL(String(_iscritto.id));

          const _url = await self.badge_component.setEdizioneById(self.edizione.id.toString(), false);

          _iscritto.b64BadgeImage = _url;
          //console.log(_url);
        }
      }
      self.app.hideSpinner();
    }
  }
}
